export const ReportType = [
  {
    text: "Customer Delivery Advice Summary Report",
    value: "Customer Delivery Advice Summary Report",
  },
  {
    text: "Delivery Advice Summary Report",
    value: "Delivery Advice Summary Report",
  },
  {
    text: "Delivery Advice Time Stamp Report",
    value: "Delivery Advice Time Stamp Report",
  },
  {
    text: "Delivery Advice List Report",
    value: "Delivery Advice List Report",
  },
  {
    text: "Customer Invoice Detailed Report",
    value: "Customer Invoice Detailed Report",
  },
  {
    text: "Invoice List (Consolidated with remarks)",
    value: "Invoice List",
  },
  {
    text: "DA Pending To Invoice Report",
    value: "DA Pending To Invoice Report",
  },
  {
    text: "Defective CheckList Report",
    value: "Defective CheckList Report",
  },
  {
    text: "Trip CheckList Log",
    value: "Trip CheckList Log",
  },
];
export const DAReplicateSampleDownloadHeaders = [
  [
    "Container No",
    "Container Weight",
    "Container No",
    "Container Weight",
    "Container No",
    "Container Weight",
    "Container No",
    "Container Weight",
  ],
];

export const InvoiceModes = [
  {
    display_name: "Regular",
    value: "Regular",
  },
  {
    display_name: "Split",
    value: "Split",
  },
];

export const FilterStatus = [
  {
    text: "Deactivated",
    value: "Deactivated",
  },

  {
    text: "Idle",
    value: "Idle",
  },
  {
    text: "On Trip",
    value: "On Trip",
  },
  {
    text: "Assigned",
    value: "Assigned",
  },
  {
    text: "In Maintenance",
    value: "In Maintenance",
  },
];


export const statusChoice = [
  {
    display_name: "Idle",
    value: "Idle",
  },
  {
    display_name: "Deactivated",
    value: "Deactivated",
  },
   {
    display_name: "On Trip",
    value: "On Trip",
  },
   {
    display_name: "In Maintenance",
    value: "In Maintenance",
  },
 

];

export const debitNoteChoices = [
  {
    display_name: "Sub Hire",
    value: "subhire",
  },
  {
    display_name: "DA",
    value: "da",
  },
   
 

];

export const ReportCategory = [
  {
    display_name: "Finance Reports",
    value: "Finance Reports",
  },
  {
    display_name: "Delivery Advice Reports",
    value: "Delivery Advice Reports",
  },
  {
    display_name: "Trip Reports",
    value: "Trip Report",
  },
  {
    display_name: "Vehicle Reports",
    value: "Vehicle Reports",
  },
  {
    display_name: "Driver Reports",
    value: "Driver Reports",
  },
  {
    display_name: "Driver Bonus Reports",
    value: "Driver Bonus Reports",
  },
  {
    display_name: "Sub Hire Report",
    value: "Sub Hire Reports",
  },
  {
    display_name: "Other Reports",
    value: "Other Reports",
  },
];

export const statusCategory = [
  {
    display_name: "Pending",
    value: "Pending",
  },
  {
    display_name: "Verified",
    value: "Verified",
  },
  {
    display_name: "Approved",
    value: "Approved",
  },
  {
    display_name: "Rejected",
    value: "Rejected",
  },
];
export const modeTypeList = [
  {
    display_name: "E-Mail",
    value: "E-Mail",
  },
  {
    display_name: "Call",
    value: "Call",
  },
  {
    display_name: "Whatsapp",
    value: "Whatsapp",
  },
];

export const serviceTypeListCategory = [
  {
    display_name: "Local",
    value: "Local",
  },
  {
    display_name: "Cross Border",
    value: "Cross Border",
  },
];
export const IncidentType = [
  {
    display_name: "Parking",
    value: "Parking",
  },
  {
    display_name: "Speeding",
    value: "Speeding",
  },
  {
    display_name: "Other",
    value: "Other",
  },
];

export const CausedType = [
  {
    display_name: "Employee",
    value: "Employee",
  },
  {
    display_name: "Third Party",
    value: "Third Party",
  },
];

export const ClassificationType = [
  {
    display_name: "Minor",
    value: "Minor",
  },
  {
    display_name: "General",
    value: "General",
  },
  {
    display_name: "Line Wise",
    value: "Line Wise",
  },
];

export const StatusType = [
  {
    display_name: "Open",
    value: "Open",
  },
  {
    display_name: "Closed",
    value: "Closed",
  },
];

export const FinanceReportList = [
  {
    display_name: "Invoice Da Detail Report",
    value: "Invoice Da Detail Report",
  },
  {
    display_name: "Customer Invoice Detailed Report",
    value: "Customer Invoice Detailed Report",
  },
  {
    display_name: "Invoice List",
    value: "Invoice List",
  },
  {
    display_name: "DA Pending To Invoice Report",
    value: "DA Pending To Invoice Report",
  },
  {
    display_name: "Payment Receipt Report",
    value: "Payment Receipt Report",
  },
  {
    display_name: "Credit Note Detailed Report",
    value: "Credit Note Detailed Report",
  },
];

export const RequestStatusType = [
  {
    display_name: "Pending",
    value: "Pending",
  },
  {
    display_name: "Verified",
    value: "Verified",
  },
  {
    display_name: "Approved",
    value: "Approved",
  },
];

export const serviceTypeList = [
  {
    display_name: "Local",
    value: "Local",
  },
  {
    display_name: "Cross Border",
    value: "Cross Border",
  },
];

export const invoiceTypeFormats = [
  {
    display_name: "General",
    value: "General",
  },
  {
    display_name: "Line Wise",
    value: "Line Wise",
  },
];
export const TaxTypes = [
  {
    display_name: "Standard Rated",
    value: "Standard Rated",
  },
  {
    display_name: "Zero Rated",
    value: "Zero Rated",
  },
  {
    display_name: "Exempt Rated",
    value: "Exempt Rated",
  },
  {
    display_name: "Exclude Rated",
    value: "Exclude Rated",
  },
  {
    display_name: "A2",
    value: "A2",
  },
  {
    display_name: "A3",
    value: "A3",
  },
  {
    display_name: "V3",
    value: "V3",
  },
  {
    display_name: "V4",
    value: "V4",
  },
  {
    display_name: "VX",
    value: "VX",
  },
  {
    display_name: "VY",
    value: "VY",
  },
];

export const ReportFrequency = [
  { display_name: "Daily", value: "Daily" },
  { display_name: "Weekly", value: "Weekly" },
  { display_name: "Monthly", value: "Monthly" },
  { display_name: "Quarterly", value: "Quarterly" },
];
